export const generateContactsCSV = (contacts) => {
  const headers = [
    'ID',
    'First Name',
    'Last Name',
    'Title',
    'Type',
    'Company',
    'Created (mm/dd/yyyy)',
    'State',
    'Email',
    'Phone',
  ];

  const rows = contacts.map((contact) => [
    contact.contactID ?? '',
    contact.firstName ?? '',
    contact.lastName ?? '',
    contact.title ?? '',
    contact.type ?? '',
    contact.companyName ?? '',
    contact.dateCreated ?? '',
    contact.contactState ?? '',
    contact.emailAddress ?? '',
    contact.phoneNumber ?? '',
  ]);

  const csvContent = [headers, ...rows]
    .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  const now = new Date();
  const timestamp = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
  link.setAttribute('download', `contacts_${timestamp}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
